import { render, staticRenderFns } from "./OptionalCard.vue?vue&type=template&id=6fdd558a&"
import script from "./OptionalCard.vue?vue&type=script&lang=js&"
export * from "./OptionalCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports